export { default } from './part-contacy-detailes';
